<nav class="navbar navbar-default blue-bg">
    <div class="container container-fluid">
        <div class="navbar-header">
            <h1 class="navbar-brand">{{title}}</h1>
        </div>
    </div>
</nav>
<p-tabView (onChange)="tabChanged($event)" [(activeIndex)]="activeIndex">
    <p-tabPanel id="entityTab">
        <ng-template pTemplate="header">
            <div [ngClass]="{'error' : ent.editFormInvalid()}">Dane podmiotu</div>
        </ng-template>
        <entity #ent
                [company]="document.company"
                [companyType]="companyType"
                (noPeselChanged)="noPesel=$event"
                (registryDataInvalidChanged)="registryDataInvalid=$event"
                [(pesel)]="document.company.personalData && document.company.personalData.pesel"
                [(identityType)]="document.company.personalData && document.company.personalData.identityType"
                [(identityValue)]="document.company.personalData && document.company.personalData.identityValue">
        </entity>
      
    </p-tabPanel>
    <p-tabPanel *ngIf="companyType==CompanyType.LEGAL">
        <ng-template pTemplate="header">
            <div [ngClass]="{'error' : shr.editFormInvalid()}">Członkowie zarządu</div>
        </ng-template>
        <shareholders #shr
            [docId]="document.id"
            [company]="document.company"
            [(shareholders)]="document.company.shareholders!"
            (onlyPeselsChange)="onlyPesels=$event">
        </shareholders>
    </p-tabPanel>
    <p-tabPanel *ngIf="companyType==CompanyType.PARTNERSHIP">
        <ng-template pTemplate="header">
            <div [ngClass]="{'error' : part.editFormInvalid()}">Wspólnicy</div>
        </ng-template>
        <partners #part
                [docId]="document.id"
                [company]="document.company"
                [(shareholders)]="document.company.shareholders!"
                (onlyPeselsChange)="onlyPesels=$event">
        </partners>
    </p-tabPanel>
    <p-tabPanel>
        <ng-template pTemplate="header">
            <div [ngClass]="{'error' : assignee.editFormInvalid()}">Pełnomocnik</div>
        </ng-template>
        <assignee #assignee
            [docId]="document.id"
            (assigneeChange)="isAssignee=$event"
            (proxyChange)="proxy=$event"
            (authFileChange)="attachmentByTypeArray[AttachmentType.AUTHORIZATION]=$event"
            (authPaymentFileChange)="attachmentByTypeArray[AttachmentType.AUTH_PAYMENT]=$event">
        </assignee>
    </p-tabPanel>
    <p-tabPanel>
        <ng-template pTemplate="header">
            <div [ngClass]="{'error' : att.editFormInvalid()}">Załączniki</div>
        </ng-template>
        <attachments #att
            [docId]="document.id"
            [company]="document.company"
            [companyType]="companyType"
            (krkFileChange)="attachmentByTypeArray[AttachmentType.KRK]=$event"
            (paymentFileChange)="attachmentByTypeArray[AttachmentType.PAYMENT]=$event"
            (registerFileChange)="attachmentByTypeArray[AttachmentType.REGISTER]=$event">
        </attachments>
    </p-tabPanel>
    <p-tabPanel header="Dane kontaktowe">
        <ng-template pTemplate="header">
            <div [ngClass]="{'error' : con.editFormInvalid()}">Dane kontaktowe</div>
        </ng-template>
        <contact #con
            [(name)]="document.company.contactData.contactPerson"
            [(email)]="document.company.contactData.email"
            [(mobilePhone)]="document.company.contactData.mobilePhone"
            [(landlinePhone)]="document.company.contactData.landlinePhone">
        </contact>
    </p-tabPanel>
    <p-tabPanel>
        <ng-template pTemplate="header">
            <div [ngClass]="{'error' : sum.editFormInvalid()}">Podsumowanie</div>
        </ng-template>
        <summary #sum
                 [company]="document.company"
                 [companyType]="companyType"
                 [isAssignee]="isAssignee"
                 [noPesel]="noPesel"
                 [onlyPesels]="onlyPesels"
                 [proxy]="proxy"
                 [authFileName]="attachmentByTypeArray[AttachmentType.AUTHORIZATION]?.name"
                 [authPaymentFileName]="attachmentByTypeArray[AttachmentType.AUTH_PAYMENT]?.name"
                 [registerFileName]="attachmentByTypeArray[AttachmentType.REGISTER]?.name"
                 [paymentFileName]="attachmentByTypeArray[AttachmentType.PAYMENT]?.name"
                 [krkFileName]="attachmentByTypeArray[AttachmentType.KRK]?.name"
                 [(dataAgree)]="dataAgree"
                 [(conditionsAgree)]="conditionsAgree"
                 [(rodoAgree)]="rodoAgree">
        </summary>
    </p-tabPanel>
<br/>
</p-tabView>

<div class="flex">
    <p-button label="Wybór wniosku" icon="pi pi-backward" iconPos="left" styleClass="ml" (click)="chooseForm()"></p-button>
    <div class="wrapper">
        <button *ngIf="activeTab!=Tab.ENTITY" pButton label="Wstecz" icon="pi pi-arrow-circle-left" iconPos="left" (click)="goBack()"></button>&nbsp;
        <button *ngIf="activeTab!=Tab.SUMMARY" pButton label="Dalej" icon="pi pi-arrow-circle-right" iconPos="right" (click)="goForward()"></button>
        <button *ngIf="activeTab==Tab.SUMMARY" pButton label="Złóż" [loading]="sendingProposal" icon="pi pi-arrow-circle-right" iconPos="right" (click)="sendProposal()"></button>
    </div>
    <span class="mr md:visible">
    </span>
</div>

<p-confirmDialog header="Uwaga"
                 icon="pi pi-exclamation-triangle"
                 acceptLabel="Tak"
                 rejectLabel="Nie">
</p-confirmDialog>